import ApisServiceApp from './ApisServiceApp'
import { apiRequest } from '@/utils/apiRequestUtils'
import { banHangListParamsFromQueryString } from '@/utils/banHangListQueryUtils'
import { normalizeDetailResponse, normalizeListResponse, type PagedListResult } from '@/utils/apiResponseUtils'
import {
  blobResponseConfig,
  ensureExcelBlob,
  postMultipartFile,
} from '@/utils/blobApiUtils'

const PREFIX = '/chuyen-hang'

export const fetchChuyenHangList = (search: string): Promise<PagedListResult<Record<string, unknown>>> => {
  const params = banHangListParamsFromQueryString(search)
  return apiRequest(
    ApisServiceApp.get(`${PREFIX}/danh-sach-phieu-chuyen-hang`, { params }).then((res: unknown) => {
      const { data, paging, summary } = normalizeListResponse(res as Parameters<typeof normalizeListResponse>[0])
      return { data: data as Record<string, unknown>[], paging, summary }
    }),
  )
}

export const fetchMaPhieuChuyenMoi = (): Promise<{ maPhieuChuyen: string }> =>
  apiRequest(
    ApisServiceApp.get(`${PREFIX}/ma-phieu-chuyen-moi`).then((res: unknown) =>
      normalizeDetailResponse(res as { data?: { maPhieuChuyen: string } }),
    ),
  )

export const taoPhieuChuyenHang = (body: Record<string, unknown>) =>
  apiRequest(ApisServiceApp.post(`${PREFIX}/tao-phieu-chuyen-hang`, body))

export const fetchChuyenHangDetail = (id: string | number) =>
  apiRequest(
    ApisServiceApp.get(`${PREFIX}/${id}/chi-tiet-phieu-chuyen-hang`).then((res: unknown) => ({
      data: normalizeDetailResponse(res as { data?: Record<string, unknown> }),
    })),
  )

export const capNhatPhieuChuyenHang = (id: string | number, body: Record<string, unknown>) =>
  apiRequest(ApisServiceApp.put(`${PREFIX}/${id}/cap-nhat-phieu-chuyen-hang`, body))

export const xoaPhieuChuyenHang = (id: string | number) =>
  apiRequest(ApisServiceApp.delete(`${PREFIX}/${id}/xoa-phieu-chuyen-hang`))

export const batDauChuyenPhieuChuyenHang = (
  id: string | number,
  body?: { ngayChungTu?: string },
) =>
  apiRequest(
    ApisServiceApp.patch(`${PREFIX}/${id}/bat-dau-chuyen-phieu-chuyen-hang`, body ?? {}),
  )

export const hoanThanhXuatPhieuChuyenHang = (id: string | number) =>
  apiRequest(ApisServiceApp.patch(`${PREFIX}/${id}/hoan-thanh-xuat-phieu-chuyen-hang`, {}))

export const xacNhanNhanPhieuChuyenHang = (id: string | number, body?: Record<string, unknown>) =>
  apiRequest(ApisServiceApp.patch(`${PREFIX}/${id}/xac-nhan-nhan-hang-phieu-chuyen-hang`, body ?? {}))

export async function xuatChuyenHangTongQuanBlob(search?: string): Promise<Blob> {
  const params = search ? banHangListParamsFromQueryString(search) : {}
  const blob = (await apiRequest(
    ApisServiceApp.get<Blob>(`${PREFIX}/xuat-excel-tong-quan`, { ...blobResponseConfig, params }),
  )) as unknown as Blob
  return ensureExcelBlob(blob)
}

export async function xuatChuyenHangChiTietBlob(search?: string): Promise<Blob> {
  const params = search ? banHangListParamsFromQueryString(search) : {}
  const blob = (await apiRequest(
    ApisServiceApp.get<Blob>(`${PREFIX}/xuat-excel-chi-tiet`, { ...blobResponseConfig, params }),
  )) as unknown as Blob
  return ensureExcelBlob(blob)
}

export async function taiTemplateChuyenHangBlob(): Promise<Blob> {
  const blob = (await apiRequest(
    ApisServiceApp.get<Blob>(`${PREFIX}/tai-template-phieu-chuyen-hang`, blobResponseConfig),
  )) as unknown as Blob
  return ensureExcelBlob(blob)
}

export const nhapHangHoaTuExcelChuyenHang = (id: string | number, file: File) =>
  apiRequest(postMultipartFile(`${PREFIX}/${id}/nhap-hang-hoa-tu-excel-chuyen-hang`, file))

/** FE đã parse Excel → POST JSON `chuyen-hang-nhap-danh-sach`. */
export const nhapDanhSachPhieuChuyenHang = (
  rows: Array<{
    maHang: string
    soLuongChuyen: number
    giaChuyen?: number
    giamGia?: number
  }>,
  opts: { chiNhanhDenId: string },
) =>
  apiRequest(
    ApisServiceApp.post(`${PREFIX}/chuyen-hang-nhap-danh-sach`, rows, {
      params: { chiNhanhDenId: opts.chiNhanhDenId },
    }),
  )

/** @deprecated Dùng `nhapDanhSachPhieuChuyenHang`. */
export const nhapPhieuChuyenHangTuExcel = (
  file: File,
  opts: { chiNhanhDenId: string },
) =>
  apiRequest(
    postMultipartFile(`${PREFIX}/nhap-phieu-tu-excel`, file, {
      chiNhanhDenId: opts.chiNhanhDenId,
    }),
  )
